var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStatePromoArt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 169,
    viewBox: "0 0 211 169",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2E44",
    strokeWidth: 1.4,
    d: "M0 168V32c0-6.627 5.373-12 12-12h137c6.627 0 12 5.373 12 12v136"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2E44",
    strokeWidth: 1.4,
    d: "M48 168V32c0-6.627 5.373-12 12-12h137c6.627 0 12 5.373 12 12v136"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 80,
    x: 5,
    y: 25,
    fill: "#212139",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 80,
    x: 53,
    y: 25,
    fill: "#212139",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 10,
    y: 113,
    fill: "#212139",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 73,
    y: 113,
    stroke: "#2E2E44",
    strokeWidth: 1.4,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13132B",
    stroke: "#2E2E44",
    strokeWidth: 1.4,
    d: "M24 168V12c0-6.627 5.373-12 12-12h137c6.627 0 12 5.373 12 12v156"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 80,
    x: 29,
    y: 5,
    fill: "#212139",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17172F",
    d: "M65.67 69.352L80.977 54.17a3.104 3.104 0 0 1 4.381.017l5.558 5.595a3.097 3.097 0 0 0 4.395 0l20.34-20.478a3.097 3.097 0 0 1 4.482.09l27.49 30.011A1.549 1.549 0 0 1 146.481 72h-79.72a1.549 1.549 0 0 1-1.091-2.648z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 24.5,
    r: 11.5,
    fill: "#17172F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E2E44",
    fillRule: "nonzero",
    d: "M85 125.233l2.222 1.27a.429.429 0 0 0 .629-.474l-.581-2.359 1.91-1.567a.429.429 0 0 0-.238-.759l-2.537-.203-1.014-2.267a.429.429 0 0 0-.782 0l-1.014 2.267-2.537.203a.429.429 0 0 0-.237.759l1.909 1.567-.58 2.36a.429.429 0 0 0 .628.474l2.222-1.27zM97 125.233l2.222 1.27a.429.429 0 0 0 .629-.474l-.581-2.359 1.91-1.567a.429.429 0 0 0-.238-.759l-2.537-.203-1.014-2.267a.429.429 0 0 0-.782 0l-1.014 2.267-2.537.203a.429.429 0 0 0-.237.759l1.909 1.567-.58 2.36a.429.429 0 0 0 .628.474l2.222-1.27zM109 125.233l2.222 1.27a.429.429 0 0 0 .629-.474l-.581-2.359 1.91-1.567a.429.429 0 0 0-.238-.759l-2.537-.203-1.014-2.267a.429.429 0 0 0-.782 0l-1.014 2.267-2.537.203a.429.429 0 0 0-.237.759l1.909 1.567-.58 2.36a.429.429 0 0 0 .628.474l2.222-1.27zM121 125.233l2.222 1.27a.429.429 0 0 0 .629-.474l-.581-2.359 1.91-1.567a.429.429 0 0 0-.238-.759l-2.537-.203-1.014-2.267a.429.429 0 0 0-.782 0l-1.014 2.267-2.537.203a.429.429 0 0 0-.237.759l1.909 1.567-.58 2.36a.429.429 0 0 0 .628.474l2.222-1.27zM133 125.233l2.222 1.27a.429.429 0 0 0 .629-.474l-.581-2.359 1.91-1.567a.429.429 0 0 0-.238-.759l-2.537-.203-1.014-2.267a.429.429 0 0 0-.782 0l-1.014 2.267-2.537.203a.429.429 0 0 0-.237.759l1.909 1.567-.58 2.36a.429.429 0 0 0 .628.474l2.222-1.27z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 34,
    y: 93,
    stroke: "#2E2E44",
    strokeWidth: 1.4,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 5,
    x: 80,
    y: 97,
    fill: "#2E2E44",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 5,
    x: 80,
    y: 106,
    fill: "#2E2E44",
    rx: 2.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStatePromoArt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-state-promo-art.9322e8a1d3c5a7ad1b3ee963fc65d77a.svg";